"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const UserTransactionType_1 = require("../transactions/User/UserTransactionType");
const UserWithTransactions_1 = require("../models/UserWithTransactions");
class UserService {
    constructor(cryptoService, transitionService) {
        this.cryptoService = cryptoService;
        this.transactionService = transitionService;
    }
    register(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const authenticatedUser = this.cryptoService.getUserByLoginAndPassword(login, password);
            const publicUser = authenticatedUser.getPublicUser();
            const transaction = yield this.transactionService.createTransaction(publicUser, UserTransactionType_1.UserTransactionType.t, publicUser);
            yield this.transactionService.signAndSend(authenticatedUser, transaction);
            return authenticatedUser;
        });
    }
    login(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const authenticatedUser = this.cryptoService.getUserByLoginAndPassword(login, password);
            const userWithPubKey = yield this.getUserByPublicKey(authenticatedUser.getPublicUser().publicKey);
            if (!userWithPubKey) {
                throw new Error('User has not been registered');
            }
            return authenticatedUser;
        });
    }
    // noinspection JSUnusedGlobalSymbols
    getUsersWithTransactions(removeIgnored) {
        return __awaiter(this, void 0, void 0, function* () {
            const usersWithTransactions = [];
            const allTransactions = yield this.transactionService.getTransactions(removeIgnored);
            const usersIndex = new Map();
            for (const tx of allTransactions) {
                if (tx.type === UserTransactionType_1.UserTransactionType.t) {
                    const user = tx.model;
                    usersIndex.set(user.publicKey, new UserWithTransactions_1.UserWithTransactions(user, []));
                }
            }
            for (const tx of allTransactions) {
                const userWithTransactions = usersIndex.get(tx.creator.publicKey);
                if (userWithTransactions) {
                    userWithTransactions.addTransaction(tx);
                }
            }
            usersIndex.forEach((userWithTransactions) => {
                usersWithTransactions.push(userWithTransactions);
            });
            return usersWithTransactions;
        });
    }
    getUserByPublicKey(publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTransactions = yield this.transactionService.getTransactions();
            for (const tx of storedTransactions) {
                if (tx.type !== UserTransactionType_1.UserTransactionType.t) {
                    continue;
                }
                const user = tx.model;
                if (user.publicKey === publicKey) {
                    return user;
                }
            }
            return null;
        });
    }
}
exports.UserService = UserService;
